import { GTAG_CONVERSION_LABEL } from 'gatsby-env-variables';

import helpers from 'utils/helpers';
import security from 'utils/security';

const proposal = ({ stepName, payload }) => {
  const entitiesMapper = {
    cpf: {
      'document-number': helpers.string.removeSpecialAndEmptyChars(
        payload?.document_number,
      ),
      'source-url': helpers.session.getSourceUrl(),
      'referrer-url': helpers.session.getReferrerUrl(),
      'intent-segment-account': payload?.intentSegmentAccount || '',
      analytics: {
        'session-id': helpers.session.getSessionId(),
        'anonymous-id': helpers.session.getAnonymousId(),
        'google-client-id': helpers.session.getGoogleClientId(),
        'google-click-id': helpers.session.getGoogleClickId(),
        'facebook-click-id': helpers.session.getFacebookClickId(),
        'tiktok-click-id': helpers.session.getTiktokClickId(),
        'order-id': helpers.random.uuid(),
        'conversion-label': GTAG_CONVERSION_LABEL,
      },
      csid: security.getBiocatchID(),
    },
    nome: {
      'full-name': helpers.string.removeSpecialChars(payload?.name),
      'email-opt-in': payload?.emailOptIn,
    },
    email: {
      email: helpers.string.removeEmptySpacesString(payload?.email),
    },
    celular: {
      cellphone: helpers.string.removeSpecialAndEmptyChars(payload?.cellphone),
      'whatsapp-opt-in': payload?.whatsappOptIn,
      'sending-mode': payload?.sendingMode,
      'whatsapp-feature-enabled': payload?.whatsappOptIn,
    },
    otp: {
      'otp-token': payload?.otpToken,
    },
  };

  return entitiesMapper?.[stepName];
};

export default {
  proposal,
};
